import { defineMessages } from 'react-intl';

const messages: {
	loadingThreadsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	loadingThreadsLabel: {
		id: 'rovo-for-you.threads-list-skeleton.loading-threads-label',
		defaultMessage: 'Loading threads',
		description: 'Accessible label for the threads list skeleton loading state',
	},
});

export default messages;
